import { createReducer, on } from '@ngrx/store';
import { Pagination } from '@core/interface/core';
import { ItAssetsConfigurationItem, ItAssetsConfigurationListItem } from '@core/interface/it_assets/itAssetsConfiguration';
import { ItAssetsConfigurationActions } from './itAssets-configuration.actions';

export interface ListItemState {
  data: ItAssetsConfigurationItem[];
  isLoading: boolean;
  isDeleted: boolean;
  pagination: Pagination | null;
}

export type ItAssetsConfigurationMasterState = Record<ItAssetsConfigurationListItem, ListItemState>;
const ListItems = Object.fromEntries(
  Object.values(ItAssetsConfigurationListItem).map((key) => [
    key,
    {
      data: [],
      isLoading: true,
      isDeleted: false,
      pagination: null,
    },
  ])
) as unknown as Record<ItAssetsConfigurationListItem, ListItemState>;
export const initialState: ItAssetsConfigurationMasterState = {
  ...ListItems
};

export const ItAssetsConfigurationReducer = createReducer(
  initialState,
  on(ItAssetsConfigurationActions.loadItAssetsConfigurationList, (state, action) => {
    return {
      ...state,
      [action.key]: { ...state[action.key], data: [], isLoading: true },
    };
  }),
  on(ItAssetsConfigurationActions.loadItAssetsConfigurationListSuccess, (state, action) => {
    return {
      ...state,
      [action.key]: {
        ...state[action.key],
        data: action.response.data,
        isLoading: false,
        pagination: action.response.pagination,
      },
    };
  }),
  on(ItAssetsConfigurationActions.loadItAssetsConfigurationListFailure, (state, action) => {
    return {
      ...state,
      [action.key]: { ...state[action.key], data: [], isLoading: false },
    };
  }),
  on(ItAssetsConfigurationActions.updateItAssetsConfigurationSuccess, (state, action) => {
      const index = state[action.key].data.findIndex(
        (item) => item.id == action.response.data.id
      );
      let data = [...state[action.key].data];
      if (index == -1) data = [...state[action.key].data, action.response.data];
      else data[index] = action.response.data;
  
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          data: data,
        },
      };
    }),
);
